export default __webpack_public_path__ + "static/media/kids.858b0218.jpg";